import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function Clone2dDiagram({ values }: DiagramProps) {
  const count = values.count ?? [3, 3];
  const spacing = values.spacing ?? [10, 10];
  const countX = Math.max(1, Math.min(6, Math.round(count[0] ?? 3)));
  const countY = Math.max(1, Math.min(5, Math.round(count[1] ?? 3)));
  const spX = spacing[0] ?? 10;
  const spY = spacing[1] ?? 10;

  const boxW = 14, boxH = 12;
  const stepX = Math.max(boxW + 4, Math.min(38, 38));
  const stepY = Math.max(boxH + 4, Math.min(26, 26));
  const originX = 28;
  const originY = 30 + (countY - 1) * stepY;

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="2D Clone diagram">
      <defs>
        <marker id="arr-cl2" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
          <path d="M0,1 L5,3 L0,5 Z" fill={D.DIM_STROKE} />
        </marker>
        <marker id="arr-cl2-rev" markerWidth="6" markerHeight="6" refX="1" refY="3" orient="auto">
          <path d="M5,1 L0,3 L5,5 Z" fill={D.DIM_STROKE} />
        </marker>
      </defs>

      {/* Grid of boxes */}
      {Array.from({ length: countY }, (_, row) =>
        Array.from({ length: countX }, (_, col) => {
          const bx = originX + col * stepX;
          const by = originY - row * stepY;
          const isOrigin = row === 0 && col === 0;
          return (
            <rect key={`${row}-${col}`}
                  x={bx} y={by} width={boxW} height={boxH}
                  fill={isOrigin ? D.GEO_FILL : 'rgba(96,165,250,0.08)'}
                  stroke={D.GEO_STROKE}
                  strokeWidth={isOrigin ? 1.5 : 1}
                  strokeDasharray={isOrigin ? 'none' : '3 3'} />
          );
        })
      )}

      {/* X spacing arrow */}
      <line x1={originX + boxW} y1={originY + boxH + 10}
            x2={originX + stepX} y2={originY + boxH + 10}
            stroke={D.X_COLOR} strokeWidth="1" strokeDasharray={D.DIM_DASH}
            markerEnd="url(#arr-cl2)" markerStart="url(#arr-cl2-rev)" />
      <text x={originX + boxW + stepX / 2 - boxW / 2}
            y={originY + boxH + 22}
            fontSize="9" fontFamily="monospace" fill={D.X_COLOR} textAnchor="middle" opacity="0.85">
        spX={spX}
      </text>

      {/* Y spacing arrow */}
      <line x1={originX + (countX) * stepX + 6} y1={originY}
            x2={originX + (countX) * stepX + 6} y2={originY - stepY}
            stroke={D.Y_COLOR} strokeWidth="1" strokeDasharray={D.DIM_DASH}
            markerEnd="url(#arr-cl2)" markerStart="url(#arr-cl2-rev)" />
      <text x={originX + countX * stepX + 14} y={originY - stepY / 2 + 4}
            fontSize="9" fontFamily="monospace" fill={D.Y_COLOR} textAnchor="start" opacity="0.85">
        spY={spY}
      </text>

      {/* Count labels */}
      <text x={originX + (countX * stepX) / 2} y={originY + boxH + 36}
            fontSize="9" fontFamily="monospace" fill={D.X_COLOR} textAnchor="middle" opacity="0.7">
        {countX}× along X
      </text>

      <text x="8" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.45">
        count=[{count[0]},{count[1]}]  spacing=[{spX},{spY}]
      </text>
    </svg>
  );
}
